import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import classNames from "classnames";

// UI Components
import Select from "react-select";
import { Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

import { client_config } from "../../../utils/clientConfigs";
const PERMISSION_OPTIONS = [
  { label: "Read Only", value: 1 },
  { label: "User", value: 2 },
  { label: "Admin", value: 3 },
  { label: "Super Admin", value: 4 },
];

export default ({ admin_user, onUserAction }) => [
  {
    dataField: "firstname_vch",
    text: "Name",
    sort: true,
    isDummyField: true,
    formatter: (cell, user) => `${user.firstname_vch} ${user.lastname_vch}`,
  },
  {
    dataField: "email_vch",
    text: "Email",
    sort: true,
  },
  {
    dataField: "group_id_bint",
    text: "Permissions",
    isDummyField: true,
    sort: true,
    formatter: (cell, user) => {
      let permission_options = [...PERMISSION_OPTIONS];
      if (admin_user.group_id_bint > 4) {
        permission_options.push({ label: "Internal", value: 5 });
      }

      if (client_config.disabled_features.user_management) {
        return (
          <Input
            readOnly
            type="text"
            value={permission_options.find((option) => option.value === user.group_id_bint).label}
          />
        );
      }

      return (
        <Select
          value={permission_options.find((option) => option.value === user.group_id_bint)}
          options={permission_options.filter((option) => option.value <= admin_user.group_id_bint)}
          onChange={(selected) => onUserAction("update", user, selected.value)}
          isDisabled={admin_user.group_id_bint < user.group_id_bint}
        />
      );
    },
  },
  {
    dataField: "created_dt",
    text: "Registered",
    sort: true,
    formatter: (created_dt) => moment(created_dt).format("lll"),
  },
  {
    dataField: "updated_dt",
    text: "Updated",
    sort: true,
    formatter: (updated_dt) => moment(updated_dt).format("lll"),
  },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    hidden: admin_user.group_id_bint < 4 || client_config.disabled_features.user_management,
    formatter: (cell, user) => (
      <Link
        to="#"
        onClick={() => onUserAction("delete", user)}
        className={classNames({ "d-none": admin_user.user_id_bint === user.user_id_bint })}
      >
        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
      </Link>
    ),
  },
];
